const selectors = {
  MAX_BADGES: 2,
  TAG_NEW: 'new',
  TAG_SALE: 'sale'
}

function ProductCardBadges({ product }) {
  const { badges } = GM_STATE.customs
  const { tags, price, comparePrice, publishedAt } = product
  const { saleTag } = GM_STATE.product
  const productTags = Array.isArray(tags) ? tags : []
  const hasSaleTag = saleTag ? productTags.includes(saleTag) : false

  const newBadge = badges.find((badge) => badge.type === selectors.TAG_NEW)
  const saleBadge = badges.find((badge) => badge.type === selectors.TAG_SALE)

  const isNew = newBadge && (new Date() - new Date(publishedAt)) / (1000 * 60 * 60 * 24) <= 30
  const isSale = saleBadge && comparePrice > price

  const productBadges = [
    ...(isNew ? [newBadge] : []),
    ...(isSale && hasSaleTag ? [saleBadge] : []),
    ...badges.filter((badge) => productTags.includes(badge.tag))
  ].slice(0, selectors.MAX_BADGES)

  return productBadges ? (
    <div className="absolute left-0 top-0 z-2 flex flex-wrap gap-px">
      {productBadges.map((badge, index) => (
        <span
          key={index}
          className="block w-fit rounded-br-lg px-2 py-1 text-xs font-bold text-white md:px-3 md:text-sm"
          style={{ background: badge.background }}
        >
          {badge.label}
        </span>
      ))}
    </div>
  ) : null
}

export default ProductCardBadges
